/**
 * Normaliza un código escaneado o digitado para el lookup en catálogo.
 * Tolera: mayúsculas/minúsculas, guiones, espacios, tildes, apóstrofos y
 * layouts de teclado ES/EN del lector (la "columna Limpio" del sistema anterior).
 */
export function normalizarSku(entrada: string): string {
  return entrada
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // marcas diacríticas (tildes)
    .replace(/[''`´¨]/g, '')
    .replace(/[-_\s.]/g, '')
    .toUpperCase()
    .trim();
}

/** true si tras normalizar queda un código utilizable */
export function esCodigoValido(entrada: string): boolean {
  const limpio = normalizarSku(entrada);
  return limpio.length >= 3 && limpio.length <= 40 && /^[A-Z0-9]+$/.test(limpio);
}
